import React from 'react';

const B2CManagement = () => {
  return (
    <div className="b2c-management">
      <div className="page-header">
        <h2>B2C Yönetimi</h2>
        <p>B2C portal yönetimini yapın</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default B2CManagement; 